import React, { useState } from "react";
import { useCart } from "../context/CartContext.tsx";
import { ShoppingCart } from "@mui/icons-material";
import {
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Typography,
  CardActions,
  Button,
  Box,
} from "@mui/material";

const CardProduct = ({ product, onAddToCart }) => {
  const [hovered, setHovered] = useState(false);
  const [imgLoad, setImgLoad] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product);

    if (onAddToCart) {
      onAddToCart();
    }
  };

  return (
    <Card
      key={product.codProduto}
      sx={{
        width: { xs: 135, sm: 190, md: 180 },
        boxShadow: 3,
        transition: "transform 0.3s",
        marginLeft: { md: 0.5 },
        "&:hover": {
          transform: "scale(1.02)",
        },
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          height: 140, 
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {!imgLoad && (
          <CircularProgress
            size={24}
            sx={{ position: "absolute", zIndex: 1 }}
          />
        )}

        <CardMedia
          component="img"
          height="140"
          image={product.image}
          onLoad={() => setImgLoad(true)}
          sx={{
            transition: "transform 0.4s ease",
            transform: hovered ? "scale(1.1)" : "scale(1)",
            borderRadius: 2,
            display: imgLoad ? "block" : "none",
          }}
        />
      </Box>
      <CardContent>
        <Typography variant="body2" gutterBottom mt={1}>
          {product.descricao === "" ? "Sem descrição" : product.descricao} -{" "}
          {product.referencia === "" ? "Sem referencia" : product.referencia}
        </Typography>

        <Typography variant="subtitle1" color="success" mt={1}>
          R$ {product.valorX === null ? "0.00" : product.valorX.toFixed(2)}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          color="info"
          onClick={handleAddToCart}
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#357a38",
            },
            display: "flex",
            gap: 1,
            alignItems: "center",
            mt: 1,
            minWidth: "auto",
            px: { xs: 4, sm: 2 },
          }}
        >
          <ShoppingCart fontSize="medium" />
          <Typography
            variant="body2"
            sx={{
              fontSize: 8,
              display: { xs: "none", sm: "block" },
            }}
          >
            Adicionar ao carrinho
          </Typography>
        </Button>
      </CardActions>
    </Card>
  );
};

export default CardProduct;
